import { render } from "./ClientReport.vue?vue&type=template&id=5b9cf098&scoped=true"
import script from "./ClientReport.vue?vue&type=script&lang=js"
export * from "./ClientReport.vue?vue&type=script&lang=js"

import "./ClientReport.vue?vue&type=style&index=0&id=5b9cf098&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b9cf098"]])

export default __exports__